var map = {
	"./img/icon_bot.png": "572e",
	"./img/icon_conf.png": "2a52",
	"./img/icon_site.png": "79dc",
	"./img/icon_student.png": "f395",
	"./img/jury/akimov.jpg": "8e3c",
	"./img/jury/arefev.jpg": "cf7a",
	"./img/jury/boltyanskiy.jpg": "8bc0",
	"./img/jury/dedova.png": "637f",
	"./img/jury/naumov.jpg": "7800",
	"./img/logo_pravo.png": "bd83",
	"./img/partners/amulex.png": "9ad6",
	"./img/partners/oblako.png": "1a34",
	"./img/partners/ssla.png": "66e5",
	"./img/partners/trud_legal.jpg": "2387",
	"./img/partners/trud_legal.png": "b4cd",
	"./img/partners/vashe_pravo.jpg": "2b29",
	"./img/photos/1.jpg": "aedd",
	"./img/photos/10.jpg": "8fb8",
	"./img/photos/11.jpg": "3bf5",
	"./img/photos/12.jpg": "cdf0",
	"./img/photos/13.jpg": "b065",
	"./img/photos/14.jpg": "96de",
	"./img/photos/15.jpg": "863b",
	"./img/photos/16.jpg": "cb70",
	"./img/photos/17.jpg": "d029",
	"./img/photos/2.jpg": "abf7",
	"./img/photos/3.jpg": "39bc",
	"./img/photos/4.jpg": "67c7",
	"./img/photos/5.jpg": "393b",
	"./img/photos/6.jpg": "2a96",
	"./img/photos/7.jpg": "8da0",
	"./img/photos/8.jpg": "f589",
	"./img/photos/9.jpg": "2048",
	"./img/speakers/d.jpeg": "9dbe",
	"./img/speakers/glazov.jpg": "c9dd",
	"./img/speakers/ibragimova.jpg": "43c1",
	"./img/speakers/jurasov.jpg": "21e8",
	"./img/speakers/khomenko.jpg": "34c6",
	"./img/speakers/kostira.jpeg": "4f23",
	"./img/speakers/kovalenko.jpg": "e8eb",
	"./img/speakers/makarenko.jpg": "ef67",
	"./img/speakers/makarova.jpg": "f81f",
	"./img/speakers/naumov.jpg": "290c",
	"./img/speakers/no_photo.jpg": "c0a2",
	"./img/speakers/novak.jpg": "77db",
	"./img/speakers/petrov.png": "f883",
	"./img/speakers/popovtsev.jpg": "6309",
	"./img/speakers/sergievskaya.jpg": "dd99",
	"./img/speakers/vetoshkina.jpg": "7915",
	"./img/speakers/zaytsev.jpg": "c179",
	"./img/speakers/zhuchkova.jpg": "e0ab",
	"./img/wave.svg": "d0e0",
	"./scss/_base.scss": "db73",
	"./scss/_btn.scss": "a0b5",
	"./scss/variables.scss": "2295"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";